import { observable, action, makeAutoObservable } from "mobx";
import { StorageService } from "../storage";
import { getArticles, getArticlesForId, getExpertsData } from "../api/articles";
import { getLevels, getQuizzes, sendQuizzResults } from "../api/quizz";
import { getMoleculeDetails, getMolecules } from "../api/molecules";
import { getSymptomes, getSymptomesdetails } from "../api/symptomes";
import { getBibliographieArticle } from "../api/bibliographie";
import { deaccentWord, round } from "../utils/utils";
import { API_URL_PRD } from "../api/config/config";
import { deleteUserRemoteData } from "../api/user";
import { isLang, isMoleculeslistArray, isMoleculeslistObject } from "../utils/guards";
import { STORAGE_KEYS } from "../../constants";

class AppStore {
  constructor() {
    makeAutoObservable(this);
  }


  // #region GENERAL
  @observable isQuickMenuVisible = false;
  @observable isLoading: boolean = true;
  @action setIsLoading(val: boolean) {
    this.isLoading = val;
  }
  @action toggleQuickMenu() {
    this.isQuickMenuVisible = !this.isQuickMenuVisible;
    // console.log("APPSTORE => toggleQuickMenu: ", this.isQuickMenuVisible);
  }
  // #endregion

  // #region LANGUAGES
  @observable currentLanguage: Lang = "fr";
  @action setCurrentLanguage(val: Lang) {
    this.currentLanguage = val;
    StorageService.set(STORAGE_KEYS.lang, val);
  }

  @action loadApplicationLanguage() {
    const lang = StorageService.get(STORAGE_KEYS.lang)
    // console.log(" ===== LANG: ", lang);
    if (lang !== undefined && isLang(lang)) {
      this.currentLanguage = lang;
    }

  }
  // #endregion

  // #region USER
  @observable openprofil = false;
  @observable userloggedout = false;
  @observable isFirstLogin = false;
  @observable isToken = false;
  @observable authToken: string | undefined = undefined;
  @observable user: User | null =
    {
      civility: "1",
      first_name: "Doe",
      last_name: "John",
      year: "1980",
      profession: "Interne",
      email: "johndoe@gmail.com",
      address: "19 rue de la popmpe",
      zipCode: "81300",
      city: "toulouse",
    };
  @observable profilePicture = "default";
  @action setProfileValueForKey(val: any, key: string | number) {
    //@ts-ignore
    this.user[key] = val;
  }
  @action setAuthToken(val: string) {
    this.authToken = val;
  }
  @action setTokenExist(val: boolean) {
    this.isToken = val;
  }
  @action isTokenExist() {
    if (this.authToken) {
      // console.log("isTokenExist= ", this.authToken);
      this.setTokenExist(true);
    } else {
      this.setTokenExist(false);
      this.moleculesList = [];
      this.moleculeDetailsList = [];
      this.symptomesList = [];
      this.symptomesDetailsList = [];
    }
  }
  @action openProfile() {
    this.openprofil = !this.openprofil;
  }

  @action logoutProfile() {
    this.clearAuthToken();
    StorageService.remove(STORAGE_KEYS.user);
    StorageService.remove(STORAGE_KEYS.auth_token);
    this.openprofil = !this.openprofil;
    this.userloggedout = true;
    this.authToken = undefined;
    this.user = null;
    this.moleculesList = [];
    this.moleculeDetailsList = [];
    this.symptomesList = [];
    this.symptomesDetailsList = [];
  }
  @action setProfilepicture(val: string) {
    this.profilePicture = val;
  }
  @action setFirstLoggin(val: boolean) {
    this.isFirstLogin = val;
  }
  @action setUserAvatar(uri: any, update: boolean) {
    this.setProfilepicture(uri);
    if (this.user !== null) {
      this.user["avatar"] = uri;

      //update stored profile
      if (update === true) {
        this.setIsLoading(true);
        this.storeProfile({
          key: STORAGE_KEYS.user,
          data: this.user,
        });
      }
    }
  }

  @action storeProfile(payload: { key: any; data: any; }) {
    // console.log("Store profile data :", payload);

    //Write user profile for next start
    StorageService.set(payload.key, payload.data);

    if (payload.key === STORAGE_KEYS.user) {
      this.user = payload.data;
      this.setIsLoading(false);
    } else {
      this.authToken = payload.data.auth_token;
      if (this.isFirstLogin === true) {
        let newProfile = {};
        Object.keys(payload.data).forEach((val, k) => {
          // console.log(" --- storeProfile Logged: ", val, k);
          if (val !== "auth_token") {
            //@ts-ignore
            newProfile[val] = payload.data[val];
          }
        });
        this.user = newProfile as User;
        this.setFirstLoggin(false);
      }
      this.setTokenExist(true);
    }
  }

  @action clearAuthToken() {
    this.authToken = undefined;
    this.isTokenExist();
  }

  @action removeProfile() {
    // console.log("Remove profile data");
    return deleteUserRemoteData({ lang: this.currentLanguage })
      .then((res) => {
        StorageService.remove(STORAGE_KEYS.user);
        this.setIsLoading(false);
        this.setProfilepicture("default");
        this.user = null;
      });
  }

  @action loadUserProfil() {
    const user = StorageService.get(STORAGE_KEYS.user)
    if (user) {
      // console.log(`===== 1 LOADED PROFIL:`, user);
      this.user = user;
      this.setProfilepicture(
        user.avatar ? user.avatar : "default"
      );
      this.setIsLoading(false);
      // if (user !== "null") {
      //   this.user = user;
      //   this.setProfilepicture(
      //     user["avatar"] ? user["avatar"] : "default"
      //   );
      //   this.setIsLoading(false);
      // }
    }
    else {
      return
      this.setIsLoading(false);
    }


    const logged = StorageService.get(STORAGE_KEYS.loggin);
    this.setTokenExist(false);

    console.log(` ==== 2 LOGGED PROFIL:`, logged);

    if (logged) {
      this.authToken = logged.auth_token;
      this.setTokenExist(true);
      //load data if not already done
      if (isMoleculeslistArray(this.moleculesList) && this.moleculesList.length === 0) {
        this.getMolecules();
      }
      if (this.symptomesList?.length === 0) {
        this.getSymptomes();
      }
    } else {
      this.setTokenExist(false);
    }


  }
  // #endregion

  // #region MOLECULES
  @observable moleculesList: TMolecule[] = [];
  @observable moleculeDetailsList: TMoleculesdetails[] = [];
  @observable searchMoleculeResult: any[] | object = [];
  @observable moleculesDetails: any;// TMoleculesdetails = { obj: undefined, origin: undefined };
  @observable moleculesStats: { count: number; total: number; read: string[] } = {
    count: 0,
    total: 0,
    read: [],
  };
  // @action getMoleculeDetails() {
  //   console.log(" --- getMoleculeDetails ---");
  //   let arrRet = [];
  //   if (isMoleculeslistObject(this.moleculesList)) {
  //     this.moleculesList[MOLECULE_TYPE.CHIMIO].forEach(obj => {
  //       console.log("getMoleculeDetails for id: ", obj.id);
  //       getMoleculeDetails({ id: obj.id })
  //         .then((resp) => {
  //           arrRet.push({ id: obj.id, details: resp });
  //           this.moleculeDetailsList = arrRet;
  //         })
  //         .catch((err) => {
  //           console.log("getMoleculeDetails : ", err);
  //         });
  //     })
  //   }
  // }
  @action setMoleculesDetails(payload: unknown) {
    this.moleculesDetails = payload;
  }
  @action getMoleculeDetailsById(id: string) {
    getMoleculeDetails(id)
      .then(response => {
        this.setMoleculesDetails(response)
      });
  }
  @action addViewedMolecule(moleculeId: string | undefined) {
    if (!moleculeId) return;

    //Add molecule ID only if not already included
    let found = this.moleculesStats.read.findIndex(
      (item) => item === moleculeId
    );
    if (found > -1) return;

    //Add molecule ID and increment progress
    this.moleculesStats.read.push(moleculeId);
    this.moleculesStats.count = this.moleculesStats.read.length;

    //save stats to local storage
    StorageService.set(STORAGE_KEYS.moleculesStats, this.moleculesStats);
  }
  @action setMoleculesStats(val: { count: number; total: number; read: any[]; }) {
    this.moleculesStats = val;
    StorageService.set(STORAGE_KEYS.moleculesStats, val);
  }
  //Load read molecules progress stats, and put it into the store
  @action getMoleculesStats() {
    const stats = StorageService.get(STORAGE_KEYS.moleculesStats);
    if (stats) {
      this.moleculesStats.count = stats.count;
      this.moleculesStats.read = stats.read;
    }
  }
  @action getMolecules() {
    if (this.pendingMolecules) return this.pendingMolecules;

    this.pendingMolecules = getMolecules({ search: "", lg: this.currentLanguage })
      .then(res => {
        this.moleculesList = res as TMolecule[];
        this.moleculesStats.total = (res as TMolecule[]).length
      })
      .catch((err) => {
        console.log("getMolecules call ERR: ", err);
      })
      .finally(() => {
        this.pendingMolecules = null;
      });

    return this.pendingMolecules;
  }
  // #endregion

  // #region SYMPTOMES
  @observable symptomesList: TSymptome[] = [];
  @observable symptomesDetailsList: { id: string; details: TSymptomDetail; }[] = [];

  /** Chargements de listes en cours, pour ne pas lancer la meme requete deux fois. */
  pendingSymptomes: Promise<void> | null = null;
  pendingMolecules: Promise<void> | null = null;
  @observable symptomeDetail: TSymptomDetail | null = null;
  @observable symptomeCarIndex = 0;
  @observable symptomsStats: { count: number; total: number; read: string[] } = {
    count: 0,
    total: 0,
    read: [],
  };
  @action addViewedSymptom(symptomId: string | undefined) {
    if (!symptomId) return;

    //Add symptome ID only if not already included
    let found = this.symptomsStats.read.findIndex((item) => item === symptomId);
    if (found > -1) return;

    //Add symptome ID and increment progress
    this.symptomsStats.read.push(symptomId);
    this.symptomsStats.count = this.symptomsStats.read.length;

    //save stats to local storage
    StorageService.set(STORAGE_KEYS.symptomsStats, this.symptomsStats);
  }
  @action setSymptomsStats(val: { count: number; total: number; read: any[]; }) {
    this.symptomsStats = val;
    StorageService.set(STORAGE_KEYS.symptomsStats, val);
  }
  //Load read symptomes progress stats, and put it into the store
  @action getSymptomsStats() {
    this.getSymptomes()
      .then((res) => {
        return StorageService.get(STORAGE_KEYS.symptomsStats);
      })
      .then((stats) => {
        if (stats) {
          this.symptomsStats.count = stats.count;
          this.symptomsStats.read = stats.read;
        }
      });
  }
  @action setSymptomeslist(val: TSymptome[]) {
    this.symptomesList = val;
  }

  @action async getSymptomes() {
    // Plusieurs ecrans demandent la liste au meme moment au demarrage : une seule
    // requete part, les autres attendent la meme promesse.
    if (this.pendingSymptomes) return this.pendingSymptomes;

    this.pendingSymptomes = getSymptomes({ search: "", lg: this.currentLanguage })
      .then(res => {
        if (!Array.isArray(res)) return;

        res.forEach((obj) => {
          obj["image"] = [];
          //@ts-ignore
          obj["tabkey"] =
            obj.title.charAt(0) === "É" ? "E" : obj.title.charAt(0);
          // Le back-office sert les images depuis /storage/images : on utilise
          // l'URL telle qu'elle est renvoyee au lieu de la reconstruire, sinon
          // le segment "storage" saute et l'image repond 404.
          obj["image"].push(
            obj.photo && obj.photo.indexOf("http") === 0
              ? obj.photo
              : `${API_URL_PRD}/${String(obj.photo || "").replace(/^\//, "")}`
          );
          obj["text"] = obj.title;
        });

        this.setSymptomeslist(res);
        // Le prechargement de toutes les fiches (une requete par symptome) a ete
        // retire : il depassait a lui seul le quota de l'API, et son resultat
        // (symptomesDetailsList) n'etait lu nulle part. Le detail est charge a
        // l'ouverture d'une fiche via getSymptomesDetailsForId.

        //store symptomes total
        this.symptomsStats.total = res.length;
      })
      .catch((err) => {
        console.log("getSymptome call ERR: ", err);
      })
      .finally(() => {
        this.pendingSymptomes = null;
      });

    return this.pendingSymptomes;
  }

  @action getSymptomesDetails() {
    if (this.symptomesDetailsList.length > 0) return;

    let arrRet: { id: string; details: TSymptomDetail; }[] = [];
    this.symptomesList?.forEach((obj) => {
      getSymptomesdetails({ id: +obj.id })
        .then(res => {
          arrRet.push({ id: obj.id, details: res as TSymptomDetail });
          this.symptomesDetailsList = arrRet;
        })
        .catch((err) => {
          console.log("getSymptomesdetails : ", err);
        });
    });
  }
  @action getSymptomesDetailsForId(id: number, backto = null) {
    getSymptomesdetails({ id }).then(symptomDetail => {
      this.setSymptomeDetail(symptomDetail as TSymptomDetail)
    })
      .catch((err) => {
        console.log("getSymptomesDetailsForId : ", err);
      });
    return
    //console.log("getSymptomesDetailsForId for id: ", id)
    // let arrRet = [];
    // getSymptomes({ search: "", lg: "" })
    //   .then((resp: any[]) => {
    //     //console.log("---- BO Symptomes: ", resp)
    //     let arrRet = [];
    //     resp.forEach((obj) => {
    //       obj["image"] = [];
    //       obj["tabkey"] =
    //         obj.title.charAt(0) === "É" ? "E" : obj.title.charAt(0);
    //       const _imgArr = obj.photo.split("images");
    //       obj["image"].push(`${API_URL_PRD}/images${_imgArr[1]}`);
    //       obj["text"] = obj.title;
    //     });
    //     // console.log(resp)
    //     this.symptomeslist = resp;
    //     //load symptome details for specific id
    //     getSymptomesdetails({ id: id })
    //       .then((resp) => {
    //         arrRet.push(resp);
    //         this.symptomedetail = arrRet;
    //         this.backview = backto;
    //       })
    //       .catch((err) => {
    //         console.log("getSymptomesDetailsForId : ", err);
    //       });
    //   })
    //   .catch((err) => {
    //     console.log("getSymptome call ERR: ", err);
    //   });
  }
  @action setSymptomeDetail(payload: TSymptomDetail | null) {
    this.symptomeDetail = payload;
    this.backview = "symptome";
  }

  @action resetSymptomedetail() {
    this.symptomeDetail = null;
    this.backview = null;
  }

  @action setSymptomeCarIndex(id: number) {
    this.symptomeCarIndex = id;
  }

  // #endregion

  // #region ARTICLES
  @observable newsDetails: TMoleculesdetails = { obj: undefined, origin: undefined };
  @observable articles: TArticle[] = [];
  @observable articleDetails: any = undefined;
  @action setArticles(val: TArticle[]) {
    this.articles = val;
  }
  @action setArticleDetails(val: unknown) {
    this.articleDetails = val;
  }
  @action setNewsDetails(payload: TMoleculesdetails) {
    this.newsDetails = payload;
  }
  @action getArticles() {
    getArticles({ lg: this.currentLanguage })
      .then(res => {
        this.setArticles(res as TArticle[]);
      })
      .catch((err) => {
        console.log("getArticles error : ", err);
      });
  }

  @action getArticlesForID(id: number) {
    getArticlesForId({ lg: this.currentLanguage, id: id })
      .then(res => {
        this.setArticleDetails(res);
      })
      .catch((err) => {
        console.log("getArticlesForID error : ", err);
      });
  }
  // #endregion

  // #region QUIZZ
  @observable levels: TLevels | null = null;
  @observable currentLevel: TLevel | null = null;
  @observable quizzResp = {};
  @observable quizzTryCount = 0;
  //@observable quizzPhotoStep = 1;
  @observable quizzId: string = '0';
  @observable questionIndex = 0;
  @observable quizzes: TQuizzes | null = null;
  @observable currentQuestion: { id: number; data: TCurrentQuestion; } | null = null;
  @observable resQuiz: any = undefined;
  @action setCurrentLevel(val: TLevel) {
    // console.log('setCurrentLevel', val);

    this.currentLevel = val;
  }
  @action getLevels() {
    getLevels(this.currentLanguage)
      .then(res => {
        // res.globalPercentage = round(res.globalPercentage * 100);

        // res.LevelsPercentageResult.forEach((item) => {
        //   item.percentage = round(item.percentage * 100);
        // });        
        if (Object.hasOwn(res, 'globalPercentage')) {
          this.levels = res as TLevels;
        }
      })
      .catch((err) => {
        console.log("getLevels error : ", err);
      });
  }
  @action setCurrentQuestion(val: { id: number; data: TCurrentQuestion; }) {
    this.currentQuestion = val;
  }
  @action setResQuiz(val: undefined) {
    this.resQuiz = val;
  }

  @action setQuizzTryCount(val: number) {
    this.quizzTryCount = val;
  }
  // @action setquizzPhotoStep(payload: number) {
  //   this.quizzPhotoStep = payload;
  // }
  @action setQuizzId(payload: string) {
    this.quizzId = payload;
  }
  @action setQuestionIndex(payload: number) {
    this.questionIndex = payload;
  }
  @action setQuizzResp(payload: {
    id: string; val: {
      [key: number]: {
        val: number,
        validated: 0 | 1,
      }
    }
  }) {
    //@ts-ignore
    this.quizzResp[payload.id] = { ...this.quizzResp[payload.id], ...payload.val };
  }
  @action setQuizzes(payload: TQuizzes | null) {
    this.quizzes = payload;
  }
  @action getQuizzes(lv: string) {
    //console.log("--- getQuizzes -> store.quizzes ==> ", lv);
    getQuizzes({ id: +lv, lg: this.currentLanguage })
      .then((res) => {
        this.quizzes = res as TQuizzes;
        // console.log(" -- getQuizzes : ", res);
      })
      .catch((err) => {
        console.log("getQuizzes error : ", err);
      });
  }
  @action resetCurrentQuizzes() {
    // console.log("-- resetCurrentQuizzes --");
    this.quizzes = null;
  }
  @action sendQuizzResults() {
    let data: { quizz_id: string; responses: object[] } = {
      quizz_id: this.quizzId,
      responses: [],
    };

    if (this.quizzResp[this.quizzId] === undefined) return;

    Object.keys(this.quizzResp[this.quizzId]).forEach((questionId) => {
      // console.log(this.quizzResp[this.quizzId][questionId]);

      data.responses.push({
        question_id: questionId,
        answer: this.quizzResp[this.quizzId][questionId].validated,
      });
    });

    sendQuizzResults(data).then((res) => {
      this.getQuizzes(this.currentLevel?.id!);
      this.getLevels();
      this.quizzResp = {};
    });
  }
  // #endregion

  // #region INFOS
  @observable contributors: any[] = [];
  @observable biblioData: TBiblio | null = null;
  @observable expertsData: any[] = [];
  
  @action getBiblio() {
    getBibliographieArticle()
      .then(res => {
        this.biblioData = res;
      })
      .catch((err) => {
        console.log("getBiblio error : ", err);
      });
  }

  @action getExperts() {
    getExpertsData()
      .then(res => {
        this.expertsData = res || [];
      })
      .catch((err) => {
        console.log("getExperts error : ", err);
      });
  }
  // @action setContributors() {
  //   this.contributors = [
  //     {
  //       name: "Dr Vincent Sibaud",
  //       picture:
  //         "https://app-fr.one-smile.care/images/forwards/sections/forward12_section1025_photo0.jpeg",
  //       fonction:
  //         "Oncodermatologue, institut Universitaire du cancer , Toulouse Oncopole, France – Centre de lutte contre le cancer",
  //       spec: [
  //         "Expert international des toxicités dermatologiques des traitements anticancéreux - auteur de nombreux ouvrages et publications dans ce domaine",
  //         'Chairman de l’European Task Force "dermatology for cancer patients"',
  //       ],
  //       subtext:
  //         "<i><p>L'application <strong>S.O.S.</strong>, d&eacute;velopp&eacute;e par les Laboratoires dermatologiques Av&egrave;ne, a &eacute;t&eacute; con&ccedil;ue pour accompagner et former les professionnels de sant&eacute; dans la prise en charge et le conseil des patients souffrant de sympt&ocirc;mes dermatologiques li&eacute;s aux chimioth&eacute;rapies, th&eacute;rapies cibl&eacute;es, immunoth&eacute;rapie ou &agrave; la radioth&eacute;rapie.</p>\r\n<p>Avec cette application, vous pourrez :</p>\r\n<ul>\r\n<li>Apprendre &agrave; reconna&icirc;tre les principaux sympt&ocirc;mes et identifier les mol&eacute;cules inductrices</li>\r\n<li>Am&eacute;liorer la prise en charge de vos patients et leur qualit&eacute; de vie</li>\r\n<li>Tester vos connaissances gr&acirc;ce &agrave; de nombreux quiz et cas pratiques</li>\r\n<li>Etre inform&eacute; r&eacute;guli&egrave;rement sur les &eacute;volutions des nouveaux traitements et leurs effets ind&eacute;sirables</li>\r\n</ul></i>",
  //     },
  //   ];
  // }
  // #endregion

  // #region UNKNOWN
  @observable backview: string | null = null;
  @action setBackview(val: string | null) {
    this.backview = val;
  }
  @action accueilSearch(term: string, clear: undefined) {
    const mols = this.moleculesList;
    const symptoms = this.symptomesList;

    //MOLECULES
    let oMol = {};
    let tab: {}[] = [];
    Object.keys(mols).forEach((it, i) => {
      //@ts-ignore
      const aux = mols[it];
      const searchResult =
        term.length === 0
          ? aux
          : aux.filter((obj: { title: string; }) =>
            deaccentWord(obj.title.toLowerCase()).includes(
              deaccentWord(term.toLowerCase())
            )
          );
      tab = [];
      searchResult.forEach((ml: { title: string; }, i: any) => {
        const a = ml.title.substring(0, 1).toUpperCase();
        let set = {};
        //@ts-ignore
        set[a] = { ...ml, __type: "molecule" };
        tab.push(set);
      });
      //@ts-ignore
      oMol[it] = tab;
    });

    //console.log("accueilSearch | Molecules List == ", oMol)

    //SYMPTOME
    const filter_symptom =
      term.length === 0
        ? symptoms
        : symptoms.filter((obj) =>
          deaccentWord(obj.text.toLowerCase()).includes(
            deaccentWord(term.toLowerCase())
          )
        );
    const ids = Object.keys(oMol);
    // console.log("accueilSearch | Symptome List == ", filter_symptom, ids);
    filter_symptom?.forEach((smp, i) => {
      let additm = {};
      const _v = {
        id: smp.id,
        title: smp.text,
        type: smp.type,
        __type: "symptom",
      };
      //@ts-ignore
      additm[smp.tabKey] = _v;
      //@ts-ignore
      oMol[ids[0]].push(additm);
      //console.log("accueilSearch | additm: ", oMol)
    });

    //set list result
    if (clear === undefined) {
      this.searchMoleculeResult = oMol;
    } else {
      this.searchMoleculeResult = [];
    }
  }

  // @action getSymptomeForId(id: number, backto = null) {
  //   if (this.symptomeslist === null) {
  //     this.getSymptomes().then(() => {
  //       return this.symptomeslist.find(symptom => +symptom.id === id );
  //     });
  //   }
  //   else {
  //     return this.symptomeslist.find(symptom => +symptom.id === id );
  //   }

  //   let ret = {};
  //   this.symptomeslist?.forEach((obj, k) => {
  //     if (+obj.id === id) {
  //       ret = obj;
  //     }
  //   });
  //   // console.log("getSymptomeForId = ", id, ret)
  //   this.symptomedetail = ret;
  //   this.backview = backto;
  // }
  // #endregion
}

const store = new AppStore();
export default store;
